<div class="arrow"></div><div class="tooltip-inner"><ng-content></ng-content></div>